export const routeSlugs: Record<string, string> = {
  products: '/producten',
  'products-id': '/producten/:id',
  'products-id-slug': '/producten/:id/:slug',
  cart: '/winkelwagen',
  checkout: '/afrekenen',
  'checkout-payment': '/afrekenen/betalen',
  'checkout-confirmation': '/afrekenen/bevestiging',
  articles: '/examentips',
  about: '/over-examenbundel',
  article: '/artikel',
  'article-slug': '/artikel/:slug',
  'articles-category': 'categorie',
  'articles-category-slug': 'categorie/:slug',
  'mijnexamenbundel-account-subjects-and-books': 'mijn-vakken-boeken',
  'mijnexamenbundel-onboarding-step-1': 'stap-1',
  'mijnexamenbundel-onboarding-step-5': 'stap-1b',
  'mijnexamenbundel-onboarding-step-2': 'stap-2',
  'mijnexamenbundel-onboarding-step-3-learning-path': 'leerweg',
  'mijnexamenbundel-onboarding-step-3-profiles': 'profielen',
  'mijnexamenbundel-onboarding-step-3': 'stap-3',
  'mijnexamenbundel-onboarding-step-4': 'stap-4',
  'mijnexamenbundel-article': 'artikel',
  'mijnexamenbundel-article-articleId': 'artikel/:articleId',
  search: '/zoeken'
}

interface TranslatableRoute {
  name?: string
  path: string
  children?: TranslatableRoute[]
}

export const translateRoutes = function (routes: TranslatableRoute[], parentRoute: TranslatableRoute | null = null): void {
  routes.forEach((route) => {
    if (route.children) {
      translateRoutes(route.children, route)
    }
    if (route.name && routeSlugs[route.name]) {
      if (parentRoute && route.path === '') {
        parentRoute.path = routeSlugs[route.name]
      } else {
        route.path = routeSlugs[route.name]
      }
    }
  })
}
